import { ArrowRight, MessageCircle } from "lucide-react";

function openChat() {
  window.dispatchEvent(new CustomEvent("seedtech:open-chat"));
}

export default function CTA() {
  return (
    <section className="bg-cream py-20 sm:py-28">
      <div className="mx-auto max-w-5xl px-6 sm:px-12">
        <div className="relative overflow-hidden rounded-3xl bg-terracotta px-8 py-16 text-center text-cream shadow-2xl sm:px-16">
          <div className="absolute inset-0 bg-adinkra opacity-[0.08]" />
          <div className="relative">
            <p className="text-xs uppercase tracking-[0.2em] text-cream/70">Ready when you are</p>
            <h2 className="mt-3 font-display text-4xl font-semibold sm:text-5xl text-balance">
              Let&apos;s get your business <span className="italic">funded.</span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-cream/85">
              Chat with our team now. We&apos;ll review your business and tell you honestly whether we can help.
            </p>
            <button
              data-testid="footer-cta"
              onClick={openChat}
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-umber px-6 py-3.5 text-sm font-medium text-cream transition hover:-translate-y-0.5 hover:bg-umber-dark"
            >
              <MessageCircle className="h-4 w-4" /> Talk to us
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
